<footer class="footer mt-auto py-3 bg-light">
    <div class="container bg-light text-center">&copy; 2022 Delta Faucet Company</div>
</footer>